import React from "react";
import { withRouter } from "react-router";

class GoBackButton extends React.Component {
    constructor(props){
        super(props);
        this.state = {

        }
    }
    goBack = () => {
        this.props.history.goBack()
    }
    render(){
        return (
            <div onClick={this.goBack} className="back-button flex aic">
                <img src="/assets/toolkit/images/left-arr.svg" alt="" />
                <p>Go back</p>
            </div>
        )
    }
}

export default withRouter(GoBackButton);